/**
 * @flow weak
 */

export const locale = (state) => {
  if (state.locale) {
    return state.locale.get('locale');
  }
};

export const messages = (state) => {
  if (state.locale) {
    return state.locale.get('messages').toObject();
  }
};




// WEBPACK FOOTER //
// ./src/modules/locale/getters.js